export default __webpack_public_path__ + "static/media/Julia-reg.36ecaa2f.png";